export default __webpack_public_path__ + "static/media/instagram.cdf82710.svg";